// Module
var code = "<div class=\"site-detail-map-container\">\n    <div my-map my-options=\"['remove-attribution']\" class=\"site-detail-map\" ng-init=\"id = $ctrl.siteID\" id=\"{{id}}\" style=\"width:300px; height:200px;\"></div>\n    <!-- <button ng-click=\"$ctrl.doLog();\">LOG</button> -->\n</div>\n";
// Exports
module.exports = code;